// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_fW","galleryThumbnail_active":"c-q_fX","galleryThumbnail__image":"c-q_fY"};